module.exports = __webpack_public_path__ + "media/assets/images/blog/san_marco_which_color-e71486adc3cc0f1e72296b4a3350bb81.png";